import { useEffect } from "react";
import { NextRouter } from "next/router";
import { DomainInfo } from "src/api/domainInfo";
import { VisitDetails } from "src/api";
import { initDomTracingSafe } from "src/utils/domTracing";

interface UseFormInitProps {
    router: NextRouter;
    visitDetails: VisitDetails;
    domain: DomainInfo;
    goToThankYouPage: boolean | undefined;
    setGoToThankYouPage: (value: boolean) => void;
}

export function useFormInit({
    router,
    visitDetails,
    domain,
    goToThankYouPage,
    setGoToThankYouPage,
}: UseFormInitProps): void {
    useEffect(() => {
        if (router.query.lander) {
            localStorage.setItem("lander", router.query.lander as string);
        }
        setGoToThankYouPage(goToThankYouPage ?? false);

        // Initialize DOM change tracking
        const cleanup = initDomTracingSafe({ visitDetails, domain });

        return cleanup; // Cleanup observer on unmount
    }, []);
}
